import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { getOwner } from "../services/firestore";
import SEO from "../components/ui/SEO";
import Hero from "../components/sections/Hero";
import Skills from "../components/sections/Skills";
import Projects from "../components/sections/Projects";
import { Hackathons, Achievements, Certificates } from "../components/sections/EventSections";
import JourneyBanner from "../components/sections/JourneyBanner";
import Contact from "../components/sections/Contact";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Rajat Shenoi",
  url: "https://shenoi.me",
  jobTitle: "Software Developer",
  sameAs: ["https://github.com/RajatShenoi", "https://linkedin.com/in/rajatshenoi"],
};

export default function Home() {
  const { data: owner, loading } = useFetch(getOwner, []);
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.slice(1);

    const scrollTo = () => document.getElementById(id)?.scrollIntoView();
    scrollTo();

    const t = setTimeout(scrollTo, 500);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <main aria-label="Main content">
      <SEO
        title={null}
        description="Portfolio of Rajat Shenoi — projects, hackathons, certificates, and journey as a software developer."
        url="/"
      />
      <script type="application/ld+json">{JSON.stringify(JSON_LD)}</script>
      <Hero owner={owner} loading={loading} />
      <Skills />
      <Projects />
      <Hackathons />
      <Achievements />
      <Certificates />
      <JourneyBanner />
      <Contact owner={owner} loading={loading} />
    </main>
  );
}
